import { Component, OnDestroy, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { EStorageType } from '@pichincha/angular-sdk/auth'
import { storage } from '@pichincha/angular-sdk/storage'

import { environment } from '../../../environments/environment'
import { EVENT_NAMES } from '../../utils/events'

const INSURANCE_EVENTS = {
  ready: 'insurance:on:ready',
  continue: 'insurance:on:continue',
  failed: 'insurance:on:failed',
}

@Component({
  selector: 'app-insurance-layout',
  templateUrl: './insurance-layout.component.html',
  styleUrls: ['./insurance-layout.component.scss'],
})
export class InsuranceLayoutComponent implements OnInit, OnDestroy {
  storage = storage({
    storageType: EStorageType.SESSION,
    secretKey: environment.storage.key,
  })

  constructor(
    private router: Router, 
    private route: ActivatedRoute
  ) {}

  stopLoader = () => {
    const eventLoader = new CustomEvent(EVENT_NAMES.loader, {
      detail: { active: false },
    })
  
    window.dispatchEvent(eventLoader)
  }

  navigateToFiscal = () => {
    this.router.navigate(['..', 'fiscal'], { relativeTo: this.route, replaceUrl: true })
  }

  handleReady = () => {
    this.stopLoader()
  }

  handleContinue = (event: Event) => {
    const { detail } = event as CustomEvent<{ hasInsurance: boolean }>
    this.storage.set(EVENT_NAMES.insuranceConfig, { showInsuranceContract: detail.hasInsurance })
    this.navigateToFiscal()
  }

  handleFailed = () => {
    this.storage.set(EVENT_NAMES.insuranceConfig, { showInsuranceContract: false })
    this.navigateToFiscal()
  }

  ngOnInit(): void {
    window.addEventListener(INSURANCE_EVENTS.ready, this.handleReady)
    window.addEventListener(INSURANCE_EVENTS.continue, this.handleContinue)
    window.addEventListener(INSURANCE_EVENTS.failed, this.handleFailed)
  }

  ngOnDestroy(): void {
    window.removeEventListener(INSURANCE_EVENTS.ready, this.handleReady)
    window.removeEventListener(INSURANCE_EVENTS.continue, this.handleContinue)
    window.removeEventListener(INSURANCE_EVENTS.failed, this.handleFailed)
  }
}
